import { render, staticRenderFns } from "./AddRecordDialog.vue?vue&type=template&id=b2a7775c&scoped=true&"
import script from "./AddRecordDialog.vue?vue&type=script&lang=js&"
export * from "./AddRecordDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddRecordDialog.vue?vue&type=style&index=0&id=b2a7775c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a7775c",
  null
  
)

export default component.exports